import { OrderedListOutlined } from '@ant-design/icons'
import { YhBox } from '@src/components/YhBox'
import useNavModel from '@src/model/navModel';
import { Button, message, Upload } from 'antd';
import React from 'react'
import { DataTable } from './DataTable'
import { useSVehicleResourceModle } from '../vehicleResourceModel';
import { sVehicleResourceService } from '../VehicleResourceService';
import { globalPrompt } from '@src/components/YhMessage';
import useGlobalModel from '@src/model/globalModel';
import { vehicleService } from '@src/views/base/vehicle/VehicleService';

export function DataBox() {
  const { addNav } = useNavModel()
  const { user } = useGlobalModel()
  const {
    selectedRow,
    selectedRowKeys,
    selectedRowData,
    setOrderVisible,
    exportVehicleResource,
    setEditModel,
    setSelectedRowData,
    setSelectedRowKeys,
    onReset,
    loadOneData,
  } = useSVehicleResourceModle()
  const action = (
    <>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={() => {
          setSelectedRowData(undefined)
          setSelectedRowKeys([])
          setEditModel('add')
          addNav('ucms-03-01-01')
        }}
      >新增</Button>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        disabled={!(
          selectedRowKeys.length === 1 && selectedRowData?.status === 1
        )}
        onClick={async () => {
          await loadOneData()
          setEditModel('edit')
          addNav('ucms-03-01-01')
        }}
      >编辑</Button>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        disabled={selectedRowKeys.length !== 1}
        onClick={async () => {
          await loadOneData()
          setEditModel('look')
          addNav('ucms-03-01-01')
        }}
      >查看</Button>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        disabled={!(
          selectedRowKeys.length === 1 && selectedRowData?.status === 1
        )}
        onClick={() => {
          globalPrompt('modal', {
            type: 'warning',
            title: '是否删除？',
            text: '删除操作不可撤销，请确认操作!',
            onOk: async () => {
              await sVehicleResourceService.delete(selectedRowData?.id as string)
              onReset()
            }
          })
        }}
      >删除</Button>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        disabled={!(
          selectedRowKeys.length === 1 && selectedRowData?.status === 3
        )}
        onClick={() => {
          setEditModel('copy')
          addNav('ucms-03-01-01')
        }}
      >复制</Button>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        disabled={(selectedRowKeys.length === 1 && selectedRowData?.status !== 1) || selectedRowKeys.length === 0}
        onClick={() => {
          if (selectedRow?.findIndex(item => item.status !== 1) !== -1) return globalPrompt('message', { type: "warning", text: "当前选中车源有不可转订单车源！" })
          setOrderVisible(true)
        }}
      >转订单</Button>
      <Upload
        showUploadList={false}
        className="ml-15 mr-15"
        {...sVehicleResourceService.import(onReset, user.userName as string)}
        name="vehicleFile"
      >
        <Button
          className="mr-5"
          type="link"
          shape="round"
        >导入</Button>
      </Upload>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={exportVehicleResource}
      >导出</Button>
    </>
  );
  return (
    <YhBox title={<OrderedListOutlined />} action={action}>
      <DataTable />
    </YhBox>
  )
}